var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickOutside),expression:"clickOutside"}],staticClass:"rocketsearch-app",attrs:{"id":"rocketsearch-app"}},[_c('SearchBar'),_c('ResultContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }